import React from 'react';
import styles from './QuiSommesNous.module.css'; // Reusing existing page styles for consistency
import RealisationsHero from '../components/realisations/RealisationsHero/RealisationsHero';

const MentionsLegales = () => {
    return (
        <div className={styles.quiSommesNousContainer}>
            <RealisationsHero
                title="Mentions Légales"
                subtitle="Informations légales et réglementaires relatives à notre site et à notre société."
                backgroundImage="/images/plan.jpg"
            />

            <div className={styles.contentSection} style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'left', lineHeight: '1.8' }}>
                
                <h2 style={{ color: 'var(--color-primary)', marginTop: '40px', borderBottom: '2px solid var(--color-light-gray)', paddingBottom: '10px' }}>1. Informations sur l'Éditeur</h2>
                <p>
                    <strong>Nom de la société :</strong> BATIMOB<br />
                    <strong>Forme Juridique :</strong> Société par actions simplifiée (SAS)<br />
                    <strong>Adresse du Siège Social :</strong> 22 RUE DU PARADIS, 78790 ARNOUVILLE-LES-MANTES, France<br />
                    <strong>Activité (NAF / APE) :</strong> Construction d'autres bâtiments - 4120B<br />
                    <strong>Date de création :</strong> 13 mai 2020<br />
                    <strong>Dirigeant :</strong> Vincent QUINARD
                </p>

                <h2 style={{ color: 'var(--color-primary)', marginTop: '40px', borderBottom: '2px solid var(--color-light-gray)', paddingBottom: '10px' }}>2. Immatriculation</h2>
                <p>
                    <strong>SIREN :</strong> 883 363 384<br />
                    <strong>SIRET du Siège Social :</strong> 883 363 384 00016<br />
                    <strong>Numéro de TVA Intracommunautaire :</strong> FR15883363384
                </p>

                <h2 style={{ color: 'var(--color-primary)', marginTop: '40px', borderBottom: '2px solid var(--color-light-gray)', paddingBottom: '10px' }}>3. Hébergement du Site</h2>
                <p>
                    Le site est hébergé par la société <strong>LWS</strong>.<br />
                    Pour plus d'informations concernant l'hébergement, veuillez vous référer aux conditions générales de l'hébergeur.
                </p>

                <h2 style={{ color: 'var(--color-primary)', marginTop: '40px', borderBottom: '2px solid var(--color-light-gray)', paddingBottom: '10px' }}>4. Conception et Développement</h2>
                <p>
                    Ce site internet et sa solution logicielle (ERP) ont été pensés, conçus et développés par l'agence <strong>Infocolab</strong>.<br />
                    <a href="https://www.infocolab.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-secondary)', fontWeight: 'bold', textDecoration: 'none' }}>
                        Découvrir Infocolab - Solutions Digitales
                    </a>
                </p>

                <h2 style={{ color: 'var(--color-primary)', marginTop: '40px', borderBottom: '2px solid var(--color-light-gray)', paddingBottom: '10px' }}>5. Propriété Intellectuelle</h2>
                <p>
                    L'ensemble des éléments graphiques, textuels et informatiques de ce site internet sont protégés par les dispositions du Code de la propriété intellectuelle. Toute reproduction, représentation ou diffusion totale ou partielle, par quelque procédé et sous quelque support que ce soit, faite sans l'autorisation expresse et préalable de BATIMOB ou de ses partenaires, est strictement interdite et constitue une contrefaçon sanctionnée par la loi.
                </p>

                <div style={{ marginTop: '50px', padding: '20px', background: 'var(--color-light-background)', borderRadius: '10px', fontSize: '0.9rem', color: 'var(--color-text-light)', textAlign: 'center' }}>
                    Sources & mises à jour le 16/06/2026 (Insee, RNCS, etc.)
                </div>
            </div>
        </div>
    );
};

export default MentionsLegales;
